<div class="totale container" [ngClass]="{'vedisx': toggle }">
     <div class="sinistra left">

        <mat-card class="ricerca">
            <mat-card-title>{{'Ricerca'|translate}}<a (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE5CD;</i></a></mat-card-title>
            <!--mat-card-subtitle>{{'Utilizza i criteri per cercare la macchina'|translate}}</mat-card-subtitle-->
            <form>
                <mat-input-container>
                    <input [(ngModel)]="codice"  name="codice" matInput placeholder="{{'Cerca per codice'|translate}}">
                </mat-input-container><br>
                <mat-input-container>
                    <input [(ngModel)]="descrizione" name="descrizione" matInput placeholder="{{'Cerca per descrizione'|translate}}">
                </mat-input-container><br>

                <button mat-raised-button color="bottonebianco" (click)="cercaRicambi()">{{'Cerca'|translate}}</button>
            </form>
        </mat-card>
           <br>
        <a class="bottone_esploso" target="_blank" href="https://ghibli.ricambio.net/site/pagece5.wplus?ID_COUNT=ce_5_home&LN={{utente.lingua}}&CEPV=Ghibli002&CELN={{utente.lingua}}&CEME=2&NDS=CE_1194&KPRD=CE_1194&PRF=1&PRC=|R|CE_1194&CEOP=LOGOUTCE5&AUTOSTARTCEPV=1&CEURLGET_UID={{utente.uid}}&CEURLGET_usertype=g&CEURLGET_SessionID={{utente.sessionUID}}&UID={{utente.uid}}&SESSIONID={{utente.sessionUID}}" mat-raised-button color="accent">{{'Catalogo generale'|translate}}</a>
   
        <br>
        <br>
        <categoria-inline *ngIf="tipiRicambi && tipiRicambi.length>0" [categorie]="tipiRicambi" [custom]=true (onSelectCategoria)="onSelectCategoria($event)"></categoria-inline>
      </div>
    <div class="centro" style="min-height:500px;">
        <a mat-raised-button color="bianco" (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE8B6;</i></a>
        <nav>
            <ul class="nav-wrapper">
                <li><a mat-raised-button color="primary" [routerLink]="['/ricambi']">{{'Ricambi'|translate}}</a></li><li *ngIf="categoriaCorrente.id"><span>&raquo;</span><a mat-raised-button color="accent" (click)="onSelectCategoria(categoriaCorrente)">{{categoriaCorrente.nome}}</a></li><li *ngIf="categoriaCorrente.id==0 && risultati"><span>&raquo;</span><a mat-raised-button color="accent">{{'Risultati ricerca'|translate}}</a></li>
            </ul>
        </nav>
        <div class="corpo">
            <div class="listamatricole">
                <div *ngIf=" !ricerca && !risultati" class="categorie">
                    <categoria *ngIf="tipiRicambi && tipiRicambi.length>0 && !categoriaCorrente.id" [categorie]="tipiRicambi" [custom]=true (onSelectCategoria)="onSelectCategoria($event)"></categoria>
                </div>

                <div class="risultati">
                    <mat-card *ngIf="ricerca || risultati" class="matricole-macchina">

                        <!--h3 class="titologriglia">Macchine in garanzia</h3-->
                        <p *ngIf="ricerca">{{'Recupero dati in corso..'|translate}}</p>
                        <p *ngIf="!ricerca && (ricambi==undefined || ricambi.length<1) && risultati">{{'Nessun ricambio trovato.'|translate}}</p>
                        <table class="mat-data-table" cellpadding="0" cellspacing="0"  *ngIf="ricambi!=undefined && ricambi.length>0 && !ricerca">
                            <thead>
                                <tr>

                                    <th class="mdl-data-table__cell--non-numeric">
                                        <span>{{'Codice'|translate}}</span>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric" width="60%">
                                        <span>{{'Descrizione'|translate}}</span>
                                    </th>
                                    <th *ngIf="utente && utente.prezzi" class=" mdl-data-table__cell--non-numeric">
                                        <span>{{'Prezzo €'|translate}}</span>
                                    </th>
                                    <th *ngIf="utente && utente.qta" class="number qta" width="50">
                                        <span>{{'Qta'|translate}}</span>
                                    </th>
                                    <th *ngIf="utente && utente.carrello" class=" mdl-data-table__cell--non-numeric">
                                        <span></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr grid-item  *ngFor="let r of ricambi">
                                    <td>{{r.codice}}</td>
                                    <td>{{r.descrizione}}</td>
                                    <td *ngIf="utente && utente.prezzi">{{r.prezzo}}</td>
                                    <td *ngIf="utente && utente.qta" class="number qta"><input [(ngModel)]="r.qta" name="qta_{{r.id}}" type="number" min="0" step="1" size="2" /></td>
                                    <td *ngIf="utente && utente.carrello"><a class="carrello" (click)="aggiungiCarrello(r)"><i class="material-icons">&#xE854;</i></a></td>
                                </tr>
                            </tbody>
                        </table>


                    </mat-card>
                </div>
            </div>
        </div></div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-ricambi/tws-ricambi.component.html